(function () {
  if (!/\/products\/bundle-builder/.test(window.location.pathname)) return;

  var BYOB_ATC_LABEL = 'Add Bundle To Cart';

  /* rb-byob-desk-no-reflow-v1 — resized desktop windows keep desktop BYOB; phones stay mobile */
  function isDesktopByob() {
    if (typeof window.rbIsDesktopClient === 'function') return window.rbIsDesktopClient();
    try {
      return (
        window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
        !window.matchMedia('(pointer: coarse)').matches
      );
    } catch (e) {
      return window.innerWidth > 999;
    }
  }

  var DESKTOP =
    'https://cdn.shopify.com/s/files/1/0029/5682/0569/files/CR_BYOB_BANNER_Long_1.jpg?v=1783633357';
  var MOBILE = DESKTOP;
  var ATTR = 'data-rb-byob-banner';

  function isBannerCandidate(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.getAttribute(ATTR) === '1') return true;

    var tag = el.tagName;
    if (tag === 'IMG') {
      var src = (el.currentSrc || el.src || el.getAttribute('src') || '').toLowerCase();
      return (
        src.indexOf('giftbox') !== -1 ||
        src.indexOf('bundlebanner') !== -1 ||
        src.indexOf('byob') !== -1 ||
        src.indexOf('desktopbanner') !== -1 ||
        src.indexOf('mobilebanner') !== -1 ||
        /banner/i.test(el.className || '') ||
        /banner/i.test(el.getAttribute('alt') || '')
      );
    }

    if (tag === 'DIV' || tag === 'SECTION' || tag === 'HEADER' || tag === 'PICTURE') {
      var bg = '';
      try {
        bg = (window.getComputedStyle(el).backgroundImage || '').toLowerCase();
      } catch (e) {}
      var cls = (el.className || '').toString().toLowerCase();
      return (
        bg.indexOf('giftbox') !== -1 ||
        bg.indexOf('byob') !== -1 ||
        cls.indexOf('banner') !== -1 ||
        cls.indexOf('hero') !== -1
      );
    }

    return false;
  }

  function applyToImg(img, url) {
    if (!img) return;
    img.setAttribute(ATTR, '1');
    if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    if (img.hasAttribute('srcset')) img.setAttribute('srcset', url);
    if (img.hasAttribute('data-src')) img.setAttribute('data-src', url);
    if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', url);
  }

  function applyToBg(el, url) {
    if (!el) return;
    el.setAttribute(ATTR, '1');
    el.style.setProperty('background-image', 'url("' + url + '")', 'important');
    el.style.setProperty('background-size', 'cover', 'important');
    el.style.setProperty('background-position', 'center', 'important');
    el.style.setProperty('background-repeat', 'no-repeat', 'important');
  }

  function preferredUrl() {
    return window.matchMedia('(max-width: 999px)').matches ? MOBILE : DESKTOP;
  }

  function patchBundleData() {
    var url = preferredUrl();
    try {
      if (window.bundle_data && window.bundle_data.bundleBanners) {
        window.bundle_data.bundleBanners.desktopBanner = DESKTOP;
        window.bundle_data.bundleBanners.mobileBanner = MOBILE;
      }
    } catch (e1) {}

    ['easybundle_active_product_data', 'easyBundle', 'EasyBundle', 'EB_BUNDLE'].forEach(function (key) {
      try {
        var obj = window[key];
        if (!obj) return;
        if (obj.bundleBanners) {
          obj.bundleBanners.desktopBanner = DESKTOP;
          obj.bundleBanners.mobileBanner = MOBILE;
        }
      } catch (e2) {}
    });

    return url;
  }

  function swapRenderedBanners() {
    var url = patchBundleData();
    var roots = document.querySelectorAll(
      '[class*="banner" i], [class*="Banner"], [class*="hero" i], [id*="banner" i], [class*="easybundle" i], [class*="easy-bundle" i], [class*="giftBox" i], [class*="gift-box" i]'
    );

    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i += 1) {
      var img = imgs[i];
      var rect = img.getBoundingClientRect();
      var src = (img.currentSrc || img.src || '').toLowerCase();
      var nearTop = rect.top < 700 && rect.width > 280;
      var looksLikeAppBanner =
        src.indexOf('cloudfront.net/giftbox') !== -1 ||
        src.indexOf('byob') !== -1 ||
        (src.indexOf('bundle') !== -1 && src.indexOf('banner') !== -1);
      if (nearTop && (looksLikeAppBanner || isBannerCandidate(img))) {
        applyToImg(img, url);
      }
    }

    for (var r = 0; r < roots.length; r += 1) {
      var el = roots[r];
      if (!isBannerCandidate(el) && el.tagName !== 'IMG') {
        var box = el.getBoundingClientRect();
        if (box.top < 700 && box.width > 280 && box.height > 80) {
          var bg = '';
          try {
            bg = window.getComputedStyle(el).backgroundImage || '';
          } catch (e3) {}
          if (bg && bg !== 'none') applyToBg(el, url);
        }
        continue;
      }
      if (el.tagName === 'IMG') applyToImg(el, url);
      else applyToBg(el, url);
    }
  }

  /* Canna blue (#0085F9 / nearby) → emerald fill class */
  function isCannaBlue(color) {
    if (!color || color === 'transparent' || color.indexOf('rgba(0, 0, 0, 0)') === 0) return false;
    var m = color.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (!m) return false;
    var r = Number(m[1]);
    var g = Number(m[2]);
    var b = Number(m[3]);
    return r <= 45 && g >= 70 && g <= 170 && b >= 190;
  }

  function isCategoryTabEl(el) {
    return !!(el && el.closest && el.closest('.gbbCategoryTabContainer, .gbbMultipleCategoryTabsContainer, .gbbCategoriesTabsContainer'));
  }

  function remaskBlueBrand() {
    var root = document.querySelector('#gbbBundle');
    if (!root) return;

    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i += 1) {
      var el = nodes[i];

      /* Category pills are CSS-owned — don't fight them with remask classes */
      if (isCategoryTabEl(el)) {
        el.classList.remove('rb-byob-emerald-fill', 'rb-byob-emerald-text', 'rb-byob-emerald-border');
        continue;
      }

      var cs;
      try {
        cs = window.getComputedStyle(el);
      } catch (err) {
        continue;
      }

      if (isCannaBlue(cs.backgroundColor)) {
        el.classList.add('rb-byob-emerald-fill');
      } else if (
        el.classList.contains('rb-byob-emerald-fill') &&
        !/gbbProductAddButton|gbbFooterNextButton/.test(String(el.className || ''))
      ) {
        el.classList.remove('rb-byob-emerald-fill');
      }

      if (isCannaBlue(cs.color) && el.childElementCount === 0) {
        el.classList.add('rb-byob-emerald-text');
      } else {
        el.classList.remove('rb-byob-emerald-text');
      }

      if (isCannaBlue(cs.borderTopColor) || isCannaBlue(cs.outlineColor)) {
        el.classList.add('rb-byob-emerald-border');
      }
    }
  }

  /* Desktop: stop Easy Bundle from auto-scrolling when category tabs are clicked */
  function bindDesktopNoCategoryScroll() {
    if (document.documentElement.getAttribute('data-rb-byob-no-cat-scroll') === '1') return;
    document.documentElement.setAttribute('data-rb-byob-no-cat-scroll', '1');

    var freezeUntil = 0;
    var freezeY = 0;

    function isDesktop() {
      return window.matchMedia('(min-width: 1024px)').matches;
    }

    function isCategoryTab(el) {
      return !!(el && el.closest && el.closest('.gbbCategoryTabContainer'));
    }

    function inBundle(el) {
      var root = document.querySelector('#gbbBundle');
      return !!(root && el && root.contains(el));
    }

    document.addEventListener(
      'click',
      function (e) {
        if (!isDesktop()) return;
        var tab = e.target && e.target.closest ? e.target.closest('.gbbCategoryTabContainer') : null;
        if (!tab || !inBundle(tab)) return;
        freezeY = window.scrollY || window.pageYOffset || 0;
        freezeUntil = Date.now() + 900;
      },
      true
    );

    var origSIV = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {
      if (Date.now() < freezeUntil && inBundle(this) && (isCategoryTab(this) || this.closest('#gbbBundle'))) {
        return;
      }
      return origSIV.apply(this, arguments);
    };

    function patchJqAnimate($) {
      if (!$ || !$.fn || !$.fn.animate || $.fn.animate.__rbByobNoCatScroll) return;
      var origAnimate = $.fn.animate;
      function patchedAnimate(props) {
        if (
          Date.now() < freezeUntil &&
          props &&
          typeof props === 'object' &&
          Object.prototype.hasOwnProperty.call(props, 'scrollTop')
        ) {
          var el = this && this[0];
          if (
            el === window ||
            el === document ||
            el === document.documentElement ||
            el === document.body ||
            (this.is && this.is('html, body'))
          ) {
            return this;
          }
        }
        return origAnimate.apply(this, arguments);
      }
      patchedAnimate.__rbByobNoCatScroll = true;
      $.fn.animate = patchedAnimate;
    }

    patchJqAnimate(window.jQuery);
    if (window.gbb && typeof window.gbb.$ === 'function') patchJqAnimate(window.gbb.$);

    window.setTimeout(function () {
      patchJqAnimate(window.jQuery);
      if (window.gbb && typeof window.gbb.$ === 'function') patchJqAnimate(window.gbb.$);
    }, 500);
    window.setTimeout(function () {
      patchJqAnimate(window.jQuery);
      if (window.gbb && typeof window.gbb.$ === 'function') patchJqAnimate(window.gbb.$);
    }, 2000);

    window.addEventListener(
      'scroll',
      function () {
        if (!isDesktop() || Date.now() >= freezeUntil) return;
        var y = window.scrollY || window.pageYOffset || 0;
        if (Math.abs(y - freezeY) > 1) {
          window.scrollTo(0, freezeY);
        }
      },
      { passive: true }
    );
  }

  /* Card click → Easy Bundle quick-view (trigger hidden + button via jQuery) */
  function openCardQuickMenu(card) {
    if (!card || card.getAttribute('data-rb-qv-opening') === '1') return;
    var btn = card.querySelector('.gbbProductAddButton');
    if (!btn) return;

    card.setAttribute('data-rb-qv-opening', '1');

    /* GBB binds the modal to the + button — briefly enable it off-screen */
    btn.classList.add('rb-byob-qv-trigger');
    btn.style.setProperty('display', 'flex', 'important');
    btn.style.setProperty('visibility', 'visible', 'important');
    btn.style.setProperty('pointer-events', 'auto', 'important');
    btn.style.setProperty('opacity', '0', 'important');
    btn.style.setProperty('position', 'fixed', 'important');
    btn.style.setProperty('left', '-9999px', 'important');
    btn.style.setProperty('top', '0', 'important');
    btn.style.setProperty('width', '44px', 'important');
    btn.style.setProperty('height', '44px', 'important');
    btn.style.setProperty('z-index', '-1', 'important');

    try {
      if (window.gbb && typeof gbb.$ === 'function') {
        gbb.$(btn).trigger('click');
      } else if (window.jQuery) {
        window.jQuery(btn).trigger('click');
      } else {
        btn.click();
      }
    } catch (err) {}

    window.setTimeout(function () {
      btn.classList.remove('rb-byob-qv-trigger');
      [
        'display',
        'visibility',
        'pointer-events',
        'opacity',
        'position',
        'left',
        'top',
        'width',
        'height',
        'z-index'
      ].forEach(function (prop) {
        btn.style.removeProperty(prop);
      });
      card.removeAttribute('data-rb-qv-opening');
    }, 500);
  }

  function bindCardQuickMenu() {
    var root = document.querySelector('#gbbBundle');
    if (!root || root.getAttribute('data-rb-byob-card-qv') === '1') return;
    root.setAttribute('data-rb-byob-card-qv', '1');
    root.addEventListener(
      'click',
      function (e) {
        var card = e.target && e.target.closest ? e.target.closest('.gbbProductItem') : null;
        if (!card || !root.contains(card)) return;
        /* Let the synthetic + button click reach GBB */
        if (card.getAttribute('data-rb-qv-opening') === '1') return;
        if (e.target.closest('.rb-byob-qv-trigger')) return;
        /* Keep qty / variant controls usable after a product is selected */
        if (
          e.target.closest(
            '.gbbQuantityStepper, .gbbQuantityStepperAddButton, .gbbQuantityStepperRemoveButton, .gbbVariantDropdownContainer, a[href], input, select, textarea'
          )
        ) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        openCardQuickMenu(card);
      },
      true
    );
  }

  /* rb-byob-side-footer-mobile-dock-v1: true mobile uses .gbbAddProductsPageFooterHTML; phone stage uses .gbbSideFooterHTML */
  function getMobileDock(root) {
    if (!root) return null;
    return (
      root.querySelector('.gbbAddProductsPageFooterHTML') ||
      root.querySelector('.gbbPageFooterHTML.gbbSideFooterHTML') ||
      root.querySelector('.gbbSideFooterHTML')
    );
  }

  function syncMobileDockPadding() {
    if (isDesktopByob()) return;
    var root = document.querySelector('#gbbBundle');
    if (!root) return;
    var dock = getMobileDock(root);
    if (!dock) return;

    /* Align dock to phone-stage screen (beats #gbbBundle zoom skew on fixed left) */
    var stageW =
      typeof window.rbStageWidth === 'function'
        ? window.rbStageWidth()
        : Math.min(window.innerWidth, 430);
    var targetLeft = (window.innerWidth - stageW) / 2;
    var zoom = parseFloat(getComputedStyle(root).zoom);
    if (!zoom || !isFinite(zoom) || zoom <= 0) zoom = 1;

    dock.style.setProperty('width', stageW / zoom + 'px', 'important');
    dock.style.setProperty('max-width', stageW / zoom + 'px', 'important');
    dock.style.setProperty('right', 'auto', 'important');
    dock.style.setProperty('margin-left', '0', 'important');
    dock.style.setProperty('margin-right', '0', 'important');
    dock.style.setProperty('top', 'auto', 'important');
    dock.style.setProperty('bottom', '0', 'important');
    dock.style.setProperty('inset', 'auto auto 0 auto', 'important');

    dock.style.setProperty('left', '0px', 'important');
    var r0 = dock.getBoundingClientRect();
    dock.style.setProperty('left', '100px', 'important');
    var r1 = dock.getBoundingClientRect();
    var pxPerCss = (r1.left - r0.left) / 100;
    if (!pxPerCss || !isFinite(pxPerCss)) pxPerCss = zoom;
    var cssLeft = (targetLeft - r0.left) / pxPerCss;
    dock.style.setProperty('left', cssLeft + 'px', 'important');

    var h = Math.ceil(dock.getBoundingClientRect().height);
    // dock bottom: 0 + max 50px gap between products and dock
    if (h > 0) root.style.setProperty('--rb-byob-dock-h', h + 50 + 'px');
  }

  var dockScrollBound = false;
  function bindMobileDockScrollHide() {
    if (isDesktopByob()) return;
    if (dockScrollBound) return;
    dockScrollBound = true;

    var lastY = window.scrollY || 0;
    var acc = 0;
    var intent = 6;
    var minHide = 28;
    var minShow = 20;

    window.addEventListener(
      'scroll',
      function () {
        var root = document.querySelector('#gbbBundle');
        var dock = getMobileDock(root);
        if (!dock) return;

        var y = window.scrollY || 0;
        var delta = y - lastY;
        lastY = y;

        if (y <= 24) {
          dock.classList.remove('rb-byob-dock-hidden');
          acc = 0;
          return;
        }

        if (delta > intent) {
          acc += delta;
          if (acc >= minHide) {
            dock.classList.add('rb-byob-dock-hidden');
            acc = 0;
          }
        } else if (delta < -intent) {
          acc += delta;
          if (acc <= -minShow) {
            dock.classList.remove('rb-byob-dock-hidden');
            acc = 0;
          }
        }
      },
      { passive: true }
    );
  }

  function ensureViewBundleToggle() {
    if (isDesktopByob()) {
      var desktopRoot = document.querySelector('#gbbBundle');
      if (desktopRoot) {
        desktopRoot.classList.remove('rb-byob-bundle-open');
        var desktopBtn = desktopRoot.querySelector('#rb-byob-view-bundle');
        if (desktopBtn) desktopBtn.style.display = 'none';
        var desktopDock = getMobileDock(desktopRoot);
        if (desktopDock) {
          desktopDock.classList.remove('rb-byob-dock-hidden');
          desktopDock.style.removeProperty('left');
          desktopDock.style.removeProperty('width');
          desktopDock.style.removeProperty('max-width');
          desktopDock.style.removeProperty('right');
          desktopDock.style.removeProperty('inset');
          desktopDock.style.removeProperty('top');
          desktopDock.style.removeProperty('bottom');
          desktopDock.style.removeProperty('margin-left');
          desktopDock.style.removeProperty('margin-right');
        }
      }
      return;
    }

    var root = document.querySelector('#gbbBundle');
    if (!root) return;

    var cartPill = root.querySelector('.gbbCartIconWithQuantityContainer');
    if (cartPill) cartPill.style.setProperty('display', 'none', 'important');

    var list = root.querySelector('.gbbFooterBundleItemsContainer');
    var footer =
      root.querySelector('.gbbProductsFooterHTMLForMobile') ||
      getMobileDock(root);
    if (!list || !footer) return;

    var btn = root.querySelector('#rb-byob-view-bundle');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.id = 'rb-byob-view-bundle';
      btn.className = 'rb-byob-view-bundle';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'View Bundle';

      var action = footer.querySelector('.gbbFooterActionContainer');
      if (action && action.parentNode) {
        action.parentNode.insertBefore(btn, action);
      } else if (list.parentNode) {
        list.parentNode.insertBefore(btn, list.nextSibling);
      } else {
        footer.appendChild(btn);
      }

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var open = root.classList.toggle('rb-byob-bundle-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Hide Bundle' : 'View Bundle';
        if (open) {
          list.style.setProperty('display', 'grid', 'important');
        } else {
          list.style.setProperty('display', 'none', 'important');
        }
        window.requestAnimationFrame(syncMobileDockPadding);
      });
    }

    btn.style.display = '';
    if (root.classList.contains('rb-byob-bundle-open')) {
      list.style.setProperty('display', 'grid', 'important');
      btn.setAttribute('aria-expanded', 'true');
      btn.textContent = 'Hide Bundle';
    } else {
      list.style.setProperty('display', 'none', 'important');
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'View Bundle';
    }

    bindMobileDockScrollHide();
    syncMobileDockPadding();
  }

  /* The app builds the mobile button as three sibling nodes:
       .gbbNextButtonContent  •  .gbbFooterPriceSeperator  •  .gbbFooterTotalContainer (Total $X)
     so the running total is already on screen. Only the label node is ours to rename — writing a
     price into it duplicated both the total and the separator ("Add Bundle To Cart • $0.00•Total$0.00").
     The optional suffix in the pattern is what lets a button corrupted that way heal itself. */
  var ATC_TEXT = /^add\s*(?:bundle\s*)?to\s*cart(?:\s*[•·|-]\s*.*)?$/i;

  function normalizeAddToCartLabel() {
    var root = document.querySelector('#gbbBundle');
    if (!root) return;

    function normalizeAtcText(el) {
      if (!el) return;
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (t !== BYOB_ATC_LABEL && ATC_TEXT.test(t)) el.textContent = BYOB_ATC_LABEL;
    }

    root.querySelectorAll('.gbbNextButtonContent').forEach(normalizeAtcText);
    root.querySelectorAll('.gbbFooterNextButton').forEach(function (el) {
      /* No label node of its own — only safe to retext when nothing else is nested inside,
         or the total markup would be wiped along with the label. */
      if (el.querySelector('*')) return;
      normalizeAtcText(el);
    });
  }

  function normalizeAddToBundleLabel() {
    document.querySelectorAll('.gbbProductVariantAddButton').forEach(function (el) {
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^add\s*to\s*bundle$/i.test(t) && t !== 'Add To Bundle') {
        el.textContent = 'Add To Bundle';
      }
    });
  }

  function placeModalDescriptionUnderTitle() {
    document.querySelectorAll('.gbbProductVariantModalMainContainer').forEach(function (modal) {
      var desc = modal.querySelector('.gbbProductDescriptionContainer');
      var textWrap = modal.querySelector('.gbbProductCardTextContainer');
      var title = textWrap && textWrap.querySelector('.gbbProductItemTitle');
      if (!desc || !textWrap || !title) return;
      if (desc.parentElement === textWrap && title.nextElementSibling === desc) return;
      if (title.nextSibling) {
        textWrap.insertBefore(desc, title.nextSibling);
      } else {
        textWrap.appendChild(desc);
      }
    });
  }

  function titleCaseLabel(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/\b([a-z])/g, function (m, c) {
        return c.toUpperCase();
      });
  }

  function normalizeCategoryTabLabels() {
    var root = document.querySelector('#gbbBundle');
    if (!root) return;
    root.querySelectorAll('.gbbCategoryTabTitle').forEach(function (el) {
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t) return;
      var next = titleCaseLabel(t);
      if (t !== next) el.textContent = next;
    });
  }

  function normalizeDiscountMessage() {
    var root = document.querySelector('#gbbBundle');
    if (!root) return;
    root
      .querySelectorAll(
        '.gbbDiscountMessage, .gbbDiscountMessageContainer, .gbbDiscountFooterHTML'
      )
      .forEach(function (el) {
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!/product\(s\)/i.test(t)) return;
        var next = t.replace(/product\(s\)/gi, 'products');
        if (el.childElementCount === 0) {
          el.textContent = next;
        } else {
          el.querySelectorAll('.gbbDiscountMessage').forEach(function (msg) {
            var mt = (msg.textContent || '').replace(/\s+/g, ' ').trim();
            if (/product\(s\)/i.test(mt)) {
              msg.textContent = mt.replace(/product\(s\)/gi, 'products');
            }
          });
        }
      });
  }

  function forceMobileBannerLayout() {
    /* rb-byob-banner-mobile-twin-v1 — show mobile banner on phone stage (≤999) */
    var root = document.querySelector('#gbbBundle');
    if (!root) return;
    var desktop = root.querySelectorAll(
      '.gbbDesktopImageBanner, img.gbbDesktopImageBanner, [class*="DesktopImageBanner" i]'
    );
    var mobile = root.querySelectorAll(
      '.gbbMobileImageBanner, img.gbbMobileImageBanner, [class*="MobileImageBanner" i]'
    );
    var i;
    if (isDesktopByob()) {
      for (i = 0; i < desktop.length; i += 1) {
        desktop[i].style.removeProperty('display');
        desktop[i].style.removeProperty('visibility');
        desktop[i].style.removeProperty('width');
        desktop[i].style.removeProperty('height');
        desktop[i].style.removeProperty('max-height');
      }
      for (i = 0; i < mobile.length; i += 1) {
        mobile[i].style.removeProperty('display');
        mobile[i].style.removeProperty('visibility');
        mobile[i].style.removeProperty('width');
        mobile[i].style.removeProperty('height');
        mobile[i].style.removeProperty('max-height');
        mobile[i].style.removeProperty('object-fit');
      }
      return;
    }
    for (i = 0; i < desktop.length; i += 1) {
      desktop[i].style.setProperty('display', 'none', 'important');
      desktop[i].style.setProperty('visibility', 'hidden', 'important');
      desktop[i].style.setProperty('height', '0', 'important');
      desktop[i].style.setProperty('max-height', '0', 'important');
    }
    for (i = 0; i < mobile.length; i += 1) {
      mobile[i].style.setProperty('display', 'block', 'important');
      mobile[i].style.setProperty('visibility', 'visible', 'important');
      mobile[i].style.setProperty('width', '100%', 'important');
      mobile[i].style.setProperty('max-width', '100%', 'important');
      mobile[i].style.setProperty('height', 'auto', 'important');
      mobile[i].style.setProperty('max-height', 'none', 'important');
      mobile[i].style.setProperty('object-fit', 'contain', 'important');
    }
  }

  function forceMobileProductGrid() {
    /* rb-byob-mobile-coll-stack-v1 — 1-up like collection; wrappers stay full width */
    /* rb-byob-desk-no-reflow-v1 — never 1-up on a desktop client, even below 1000px */
    if (isDesktopByob()) {
      document
        .querySelectorAll(
          '#gbbBundle .gbbProductsContainer, #gbbBundle .gbbCategoryProductsContainer, #gbbBundle .gbbAddProductsContainerHTML, #gbbBundle .gbbProductsItemsContainer'
        )
        .forEach(function (el) {
          el.style.removeProperty('grid-template-columns');
          el.style.removeProperty('display');
          el.style.removeProperty('width');
          el.style.removeProperty('max-width');
          el.style.removeProperty('gap');
        });
      document.querySelectorAll('#gbbBundle .gbbProductItem').forEach(function (el) {
        el.style.removeProperty('width');
        el.style.removeProperty('max-width');
        el.style.removeProperty('min-width');
        el.style.removeProperty('flex');
      });
      return;
    }
    var root = document.querySelector('#gbbBundle');
    if (!root) return;
    root
      .querySelectorAll('.gbbCategoryProductsContainer, .gbbAddProductsContainerHTML, .gbbProductsContainer')
      .forEach(function (el) {
        el.style.setProperty('display', 'block', 'important');
        el.style.setProperty('grid-template-columns', 'none', 'important');
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('max-width', '100%', 'important');
      });
    root.querySelectorAll('.gbbProductsItemsContainer').forEach(function (el) {
      el.style.setProperty('display', 'grid', 'important');
      el.style.setProperty('grid-template-columns', '1fr', 'important');
      el.style.setProperty('gap', '13.333px', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', '100%', 'important');
    });
    root.querySelectorAll('.gbbProductItem').forEach(function (el) {
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      el.style.setProperty('min-width', '0', 'important');
      el.style.setProperty('flex', 'unset', 'important');
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      swapRenderedBanners();
      forceMobileBannerLayout();
      remaskBlueBrand();
      ensureViewBundleToggle();
      forceMobileProductGrid();
      normalizeAddToCartLabel();
      normalizeAddToBundleLabel();
      placeModalDescriptionUnderTitle();
      normalizeCategoryTabLabels();
      normalizeDiscountMessage();
      if (typeof window.rbByobMarkReady === 'function') {
        var root = document.querySelector('#gbbBundle');
        if (root && root.querySelector('.gbbProductItem, .gbbCategoryTabContainer')) {
          window.rbByobMarkReady();
        }
      }
    });
  }

  patchBundleData();
  bindDesktopNoCategoryScroll();
  bindCardQuickMenu();
  schedule();
  window.setTimeout(function () {
    bindCardQuickMenu();
    schedule();
  }, 300);
  window.setTimeout(schedule, 1000);
  window.setTimeout(schedule, 2500);
  window.setTimeout(schedule, 5000);
  window.addEventListener('resize', schedule);
  document.addEventListener(
    'click',
    function () {
      window.setTimeout(schedule, 50);
      window.setTimeout(schedule, 250);
    },
    true
  );

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      bindCardQuickMenu();
      schedule();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'style', 'class']
    });
  }
})();
